import { observable, action, runInAction, makeObservable } from "mobx";
import { BrowserStorage } from "utils/BrowserStorage";
import { handleStoreState } from "Stores/RESTStore/CoreStore";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { userInfoStore } from "Stores/UserInfoStore";

export const SSO_KEY = "ssoServer";

type serverIdType = string | number;

export class SSOLoginStore {
  state: StoreState = "RAW";
  serverId: serverIdType = null;
  saveServer = false;
  stateError = null;

  constructor() {
    makeObservable(this, {
      state: observable,
      serverId: observable,
      saveServer: observable,
      stateError: observable,
      setSaveServer: action.bound,
      setServerId: action.bound,
      fetchRedirectUrl: action.bound,
      login: action.bound,
    });

    const serverId = BrowserStorage.getPermanent("SSO_KEY");
    if (serverId) {
      this.serverId = serverId;
      this.saveServer = true;
    }
  }

  setSaveServer(saveServer: boolean) {
    this.saveServer = saveServer;
  }

  setServerId(serverId: serverIdType) {
    this.serverId = serverId;
  }

  @handleStoreState()
  async fetchRedirectUrl(serverId: serverIdType, queryName: "serverId" | "serverName", oauth2request?: string) {
    try {
      const response = await API.getData<API_StringData>(API_URL.LOGIN.getAuthUrl(), {
        [queryName]: serverId,
        oauth2request,
      });
      runInAction(() => {
        if (this.saveServer && queryName === "serverName") {
          BrowserStorage.storePermanent(SSO_KEY, serverId);
        }
      });
      return response.stringValue;
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async login(ssoId: serverIdType, queryParamsString: string) {
    try {
      const response = await API.newData<API_LoginInformation>(
        // append query params to POST request
        API_URL.LOGIN.loginWithOauth2(ssoId) + queryParamsString,
        {}
      );
      userInfoStore.authenticate(response);
    } catch (error) {
      throw error;
    }
  }
}

export const ssoLoginStore = new SSOLoginStore();
